var map = {
	"./techSpotlight.jpeg": 60575,
	"./wcc3.png": 74944,
	"./wcc4.0.jpg": 80725,
	"./wcc5.0.jpg": 18164,
	"./wcc6.png": 80941,
	"./webahon3.0.jpg": 49703,
	"./webathon4.0.png": 48768
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39458;